// removed by extract-text-webpack-plugin
module.exports = {"gwTileHeaderText":"tile-header-text-hashed__gwTileHeaderText__2Apyv"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/tiles/tileLayout/HeaderText/tile-header-text-hashed.scss
// module id = 719
// module chunks = 0